module.exports = __webpack_public_path__ + "img/food_item_2.cf6757a6.png";